(ns frontend.ui.component.button.style
  (:require
   [frontend.ui.style.theme.core
    :refer
    [border-radius color edge-size font-weight text-size]]
   [garden.color :refer [darken]]
   [garden.units :refer [px]]
   [garden.util :refer [space-join]]))

(defn label
  [{:keys [variant disabled? rounded? size]
    :or   {size :xsmall}}]
  {}
)

(defn icon
  [{:keys [variant disabled? rounded? size]
    :or   {size :xsmall}}]
  {:padding-left "8px"})

(defn button
  [{:keys [variant disabled? rounded? size]
    :or   {size :xsmall}}]
  ^{:media {{:screen :only :max-width (px 1200)}
            {:font-size "14px!important"}}}
  (let [[bg-color fg-color] (if disabled?
                              (if (= variant :link)
                                [(color [:button :disabled :link :bg])
                                 (color [:button :disabled :link :fg])]
                                [(color [:button :disabled :other :bg])
                                 (color [:button :disabled :other :fg])])
                              [(color [:button :regular variant :bg])
                               (color [:button :regular variant :fg])])
        bg-color-darker (darken bg-color 3)
        bg-color-darker-2x (darken bg-color 20)
        [edge-size-top-bottom edge-size-left-right]
        (condp = size
          :xxxsmall [size size]
          :xxsmall [:xxsmall size]
          :xsmall [:xxsmall size]
          :small [:xsmall size]
          :medium [:small size]
          :large [:medium size])]
    (with-meta
      {:padding          (space-join [(edge-size edge-size-top-bottom)
                                      (edge-size edge-size-left-right)])
       :font-size        (text-size size :size)
       :background-color bg-color
       :color            fg-color
       :border-color     (if (= variant :frame)
                           fg-color
                           bg-color)
       :border-style     "solid"
       :border-width     "2px"
       :line-height      "1"
       :outline          "none"
       :font-family      "inherit"
       :border-radius    (border-radius (if rounded? :large :xxxsmall))
       :font-weight      (font-weight :semi-bold)
       :transition       "0.3s"
       :cursor           (if disabled? "default" "pointer")
       :user-select      "none"}

      (when-not disabled?
        {:pseudo

         {:hover
          (condp = variant
            :link {:text-decoration "underline"}
            :frame {:background-color fg-color
                    :color bg-color}
            {:background-color bg-color-darker
             :border-color     bg-color-darker-2x})
          :focus
          (condp = variant
            :link {:text-decoration "underline"}
            :frame {:background-color bg-color
                    :color fg-color
                    :text-decoration "underline"}
            {:background-color bg-color-darker
             :border-color     (color [:button :focus :other :border])
             :box-shadow       (space-join [0 0 0 "1px" bg-color])})
          :active
          (condp = variant
            :link {:text-decoration "underline"}
            :frame {:background-color bg-color
                    :color fg-color}
            {:background-color bg-color-darker
             :border-color     bg-color-darker
             :box-shadow       (space-join [0 0 0 "1px" bg-color])})}})
    )))

(defn button-dropdown
  [{:keys [variant disabled? rounded? size]
    :or   {size :xsmall}}]
  (let [[bg-color fg-color] (if disabled?
                              (if (= variant :link)
                                [(color [:button :disabled :link :bg])
                                 (color [:button :disabled :link :fg])]
                                [(color [:button :disabled :other :bg])
                                 (color [:button :disabled :other :fg])])
                              [(color [:button :regular variant :bg])
                               (color [:button :regular variant :fg])])
        bg-color-darker (darken bg-color 3)
        [edge-size-top-bottom edge-size-left-right]
        (condp = size
          :xxxsmall [size size]
          :xxsmall [:xxsmall size]
          :xsmall [:xxsmall size]
          :small [:xsmall size]
          :medium [:small size]
          :large [:medium size])]
    (with-meta
      {:padding          (space-join [(edge-size edge-size-top-bottom)
                                      (edge-size edge-size-left-right)])
       :font-size        (text-size size :size)
       :background-color bg-color
       :color            fg-color
       :border-color     (if (= variant :frame)
                           fg-color
                           bg-color)
       :border-style     "solid"
       :border-width     "1px"
       :line-height      "1"
       :outline          "none"
       :border-radius    (border-radius (if rounded? :round :xxxsmall))
       :font-weight      (font-weight :semi-bold)
       :transition       "0.3s"
       :cursor           (if disabled? "default" "pointer")
       :user-select      "none"}

      (when-not disabled?
        {:pseudo
         {:hover
          (condp = variant
            :link {:text-decoration "underline"}
            :frame {:background-color fg-color
                    :color bg-color}
            {:background-color bg-color-darker
             :border-color     bg-color-darker})
          :focus
          (condp = variant
            :link {:text-decoration "underline"}
            :frame {:background-color bg-color
                    :color fg-color
                    :text-decoration "underline"}
            {:background-color bg-color-darker
             :border-color     (color [:button :focus :other :border])
             :box-shadow       (space-join [0 0 0 "1px" bg-color])})
          :active
          (condp = variant
            :link {:text-decoration "underline"}
            :frame {:background-color bg-color
                    :color fg-color}
            {:background-color bg-color-darker
             :border-color     bg-color-darker
             :box-shadow       (space-join [0 0 0 "1px" bg-color])})
          :after  {:content     "''"
                   :position    "relative"
                   :top         "1px"
                   :margin-left "8px"
                  }}}))))
